// Hooks
import { useProfile } from 'modules/profile/hooks'

type Children = unknown
type Props = {
  children: Children
  include?: boolean
}

const IsStaff = ({ children, include }: Props): JSX.Element | null => {
  const profile = useProfile()
  if (profile.is_staff || include) {
    return <>{children}</>
  }
  return null
}

export default IsStaff
